import React from 'react'
import LogoModal from './components/LogoModal';
import SignUpModal from './Sign_Up_Modal';

const SignUp = () => {
  return (
    <div className='rr_signin'>
      <LogoModal />
      <SignUpModal />
    </div>
  )
}

export default SignUp